
// Keyboard bindings
require("codemirror/keymap/vim.js");
require("codemirror/keymap/emacs.js");
require("codemirror/keymap/sublime.js");
